/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useCallback, useState, useMemo } from "react";
import axios from 'util/axios';

// import AsyncCreatableSelect from "util/component/SearchableSelect/asynccreate";
import SearchableSelect from "util/component/SearchableSelect";
import AsyncCreateSelect from "util/component/SearchableSelect/asynccreate";
import Pagination from "util/component/Pagination";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faArrowUpWideShort,
    faArrowDownWideShort,
    faTrashCan,
} from "@fortawesome/free-solid-svg-icons";

import ModalPortal from "util/component/Modal";
import { ConfirmWithMessage } from "util/component/Modal/Modal";

import { useSelector, useDispatch } from "react-redux";

const Descs = (props, ref) => {
    const { setTarget } = props;
    const [SearchCondition, SetSearchCondition] = useState({
        curPage: 1,
        boardView: 10,
        orderByColumn: "CREATE_DT",
        orderByType: "DESC",
    });
    const [List, SetList] = useState(null);
    const [BoardPager, SetBoardPager] = useState([]);

    const [ConfirmDom, SetConfirmDom] = useState(null);

    const userSelector = useSelector(store => store.user);
    const dispatch = useDispatch();


    const getList = useCallback(async () => {
        const postData = {...SearchCondition};
        if(postData.userId) {
            postData.userId = `'${postData.userId}'`;
        }
        const response = await axios
            .post(process.env.REACT_APP_API + "/pcsDesc/retrieveDescList", postData)
            .then((Response) => Response.data.data);
        SetList(response?.result);
        SetBoardPager(response?.boardPager);
    }, [SearchCondition]);

    useEffect(() => {
        getList();
    }, [SearchCondition]);

    const changeOrderby = (changeOrderByColumn) => {
        SetSearchCondition(OLD => {
            let { orderByType, orderByColumn } = {...OLD};
            if(orderByColumn === changeOrderByColumn) {
                orderByType = orderByType === "DESC" ? "ASC" : "DESC";
            } else {
                orderByType = "DESC";
            }
            return {...OLD, orderByType, orderByColumn: changeOrderByColumn}
        })
    };

    const HandleSetCondition = (selected, option) => {
        const { value } = { ...selected };
        const { name } = { ...option };

        SetSearchCondition((OLD) => ({ ...OLD, [name]: value,curPage : 1 }));
    };

    const HandleSetConditionPage = (selected, option) => {
        const { value } = { ...selected };
        const { name } = { ...option };

        SetSearchCondition((OLD) => ({ ...OLD, [name]: value }));
    };

    const deleteConfirm = async (memo, rowData) => {
        const { sheetCode, tempYn, revision } = rowData;
        const { userId } = userSelector;
        const postData = {
            sheetCode, tempYn, revision, userId, memo, message: memo
        }
        dispatch({type: "LOADING_ON"});
        try {
            const response = await axios.post(process.env.REACT_APP_API + "/pcsModify/removeSheetTemp", postData);
            await getList();
        } catch(e) {
            console.error(e);
        } finally {
            dispatch({type: "LOADING_OFF"});
        }

    }

    const deleteItem = (rowData) => {
        const confirmDom = (
            <ConfirmWithMessage
                onClose={() => SetConfirmDom(null)}
                message={"Delete Confirm"}
                onConfirm={(msg) => deleteConfirm(msg, rowData)}
            ></ConfirmWithMessage>
        );
        SetConfirmDom(confirmDom);
    }

    const renderItemList = () => {
        if (List) {
            return List.map((rowData, i) => {
                const {
                    projectNm,
                    processCd,
                    revision,
                    tempYn,
                    userNm,
                    createDt,
                    descCode,
                    userId
                } = rowData;
                return (
                    <tr key={"ownerChgDesc" + i} onClick={() => {
                        const newItem = {
                            descCode,
                            revision,
                            tempYn,
                            info: `${projectNm} / ${processCd}${tempYn === "Y" ? " / " +revision +" temp" : " / "+revision}`,
                            projectNm:`${projectNm}`,
                            processCd:`${processCd}`,
                            type: "Desc",
                            beforeOwnerId :`${userId}`
                        };
                        setTarget(OLD => {
                            if(OLD.find(e => e.descCode === newItem.descCode)) {
                                return [...OLD]
                            } else {
                                return [...OLD, newItem]
                            }
                        })
                    }}>
                        <td>{projectNm}</td>
                        <td>{processCd}</td>
                        <td>
                            <span className={tempYn === "Y" ? "bpl-temp-v2" : ""}>{revision}</span>
                        </td>
                        <td title={userNm} className={"ellipsis"}>
                            {userNm}
                        </td>
                        <td>{createDt}</td>
                        {/*descs 의 owner change 는 삭제가 필요없음*/}
{/*                        <td>
                            {tempYn === "Y" && 
                                <div style={{cursor: "pointer"}} onClick={(e) => {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    deleteItem(rowData)}
                                }>
                                    <FontAwesomeIcon icon={faTrashCan} color={"red"} />
                                </div>
                            }
                        </td>*/}
                    </tr>
                );
            });
        } else {
            return null;
        }
    };

    const itemList = useMemo(renderItemList, [List]);

    return (
        <>
            <div className={"d-flex gap-5 mb-5 opts-row"}>
                <div>
                    Project :
                    <AsyncCreateSelect
                        onChange={HandleSetCondition}
                        name="projectNm"
                        value={SearchCondition.projectNm}
                        api={"/api/common/retrieveMasterCodeList"}
                        body={{ grcd: "PROJECT" }}
                        placeholder="Project"
                        small
                    />
                </div>
                <div>
                    Process:
                    <AsyncCreateSelect
                        onChange={HandleSetCondition}
                        name="processCd"
                        value={SearchCondition.processCd}
                        api={"/api/common/retrieveMasterCodeList"}
                        body={{ grcd: "PROC" }}
                        placeholder="Process"
                        small
                    />
                </div>
                <div>
                    Owner:
                    <AsyncCreateSelect
                        onChange={HandleSetCondition}
                        name="userId"
                        value={SearchCondition.userId}
                        api="/api/user/retrieveUserListForSearch"
                        placeholder="Owner"
                        small
                    />
                </div>
            </div>
            <table className={"bpl-table-default doublerow fixed text-center  has-pagination"}>
                <colgroup>
                    <col width="100" />
                    <col width="100" />
                    <col width="100" />
                    <col width="150" />
                    <col width="150" />
                    <col width="0" />
                </colgroup>
                <thead>
                    <tr>
                        <th>Project</th>
                        <th>Process</th>
                        <th>Revision</th>
                        <th>Owner</th>
                        <th onClick={() => changeOrderby("CREATE_DT")}>
                            Create Date
                            {SearchCondition.orderByColumn === "CREATE_DT" && (
                                <>
                                    &nbsp;
                                    {SearchCondition.orderByType !== "DESC" ? (
                                        <FontAwesomeIcon icon={faArrowUpWideShort} />
                                    ) : (
                                        <FontAwesomeIcon icon={faArrowDownWideShort} />
                                    )}
                                </>
                            )}
                        </th>
                    </tr>
                </thead>
                <tbody>{itemList}</tbody>
                <tfoot>
                    <tr>
                        <td colSpan={6}>
                            <Pagination
                                data={BoardPager}
                                onClick={(page) => HandleSetConditionPage({value: page}, {name: "curPage"})}
                                style={{ marginTop: "5px", float: "right", marginRight: "-3px" }}
                            />
                        </td>
                    </tr>
                </tfoot>
            </table>
            {ConfirmDom && <ModalPortal>{ConfirmDom}</ModalPortal>}
        </>
    );
};

export default Descs;
